import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import type { AppContextCollector } from '@core/tellent-assistant-contracts';

@Injectable({ providedIn: 'root' })
export class DialogContextCollector implements AppContextCollector {
  private readonly subject = new BehaviorSubject<unknown>([]);

  public readonly key = 'dialogs';
  public readonly changes$: Observable<unknown>;

  constructor() {
    this.changes$ = this.subject.asObservable();
  }

  public snapshot(): unknown {
    return this.subject.value;
  }

  public update(dialogs: Array<{ id: string; name: string; data?: unknown }>): void {
    this.subject.next(dialogs);
  }
}
